export default __webpack_public_path__ + "static/media/carpenter-2.f0e88cf5.jpg";